function formatThaiTaxID(input: string): string {
	const numericOnly = input.replace(/\D/g, '')

	return `${numericOnly.substring(0, 1)}-${numericOnly.substring(1, 5)}-${numericOnly.substring(
		5,
		10
	)}-${numericOnly.substring(10, 13)}`
}

export default formatThaiTaxID
